import { ReactNode, useState, useMemo, Dispatch, SetStateAction, useEffect } from 'react';
import { RateResult } from '@mews-commander/data-access';
import { createSafeContext } from '@mews/framework';
import { useRateByIds } from '../../../../../queries';
import { WithEnterpriseIds } from '../../../../../types';

interface RateFormContextValue {
    rateResults: RateResult;
    setRateResults: Dispatch<SetStateAction<RateResult>>;
    isFetching: boolean;
    setIsFetching: Dispatch<SetStateAction<boolean>>;
}

export const { RateFormContextProvider: ContextProvider, useRateFormContext } = createSafeContext<
    'RateFormContext',
    RateFormContextValue
>('RateFormContext');

type RateFormProviderProps = {
    selectedRateIds?: string[];
    children: ReactNode;
} & WithEnterpriseIds;

export const RateFormProvider = ({ enterpriseIds, selectedRateIds, children }: RateFormProviderProps) => {
    const [rateResults, setRateResults] = useState<RateResult>({});
    const [isFetching, setIsFetching] = useState(false);

    const { data, isFetching: isFetchingRate } = useRateByIds(enterpriseIds, selectedRateIds);

    useEffect(() => {
        setRateResults(data || {});
        setIsFetching(isFetchingRate);
    }, [data, setRateResults, isFetchingRate, setIsFetching]);

    const contextValue = useMemo(
        () => ({
            rateResults,
            setRateResults,
            isFetching,
            setIsFetching,
        }),
        [rateResults, setRateResults, isFetching, setIsFetching]
    );

    return <ContextProvider value={contextValue}>{children}</ContextProvider>;
};
